import { useMemo } from 'react';
import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import getCoursesQuery from '../graphql/queries/getCoursesQuery';

export default function useCourses() {
  const { data, loading, error, refetch } = useQuery(getCoursesQuery);
  const courses = useMemo(() => data?.courses || [], [data]);

  return {
    courses,
    loading,
    error: getErrorMessage({ error }),
    refetchCourses: refetch,
  };
}
